export interface ToolEntry {
    id:string;
    name:string;
    description:string;
    href:string;
}

export const TOOLS:ReadonlyArray<ToolEntry> = [
    {
        id: 'leak-rate-calculator',
        name: 'Leak Rate Calculator',
        description: 'Compute annualized refrigerant leak rate and check against EPA appliance-type thresholds.',
        href: '/tools/leak-rate-calculator',
    },
    {
        id: 'refrigerant-leak-cost-calculator',
        name: 'Leak Cost Calculator',
        description: 'Estimate annual refrigerant, energy, and service costs from an unrepaired leak.',
        href: '/tools/refrigerant-leak-cost-calculator',
    },
    {
        id: 'superheat-subcooling-calculator',
        name: 'Superheat & Subcooling Calculator',
        description: 'Enter gauge pressures and line temperatures to get superheat, subcooling, and a charging diagnosis.',
        href: '/tools/superheat-subcooling-calculator',
    },
    {
        id: 'refrigerant-charge-calculator',
        name: 'Charge Size Estimator',
        description: 'Estimate total system refrigerant charge from equipment type and line-set length.',
        href: '/tools/refrigerant-charge-calculator',
    },
    {
        id: 'refrigerant-purchase-limit-calculator',
        name: 'Purchase Limit / Inventory Reconciliation',
        description: 'Reconcile refrigerant purchased vs recovered vs inventory to surface recordkeeping gaps.',
        href: '/tools/refrigerant-purchase-limit-calculator',
    },
    {
        id: 'epa-section-608-risk-estimator',
        name: 'Section 608 Risk Estimator',
        description: 'Answer a short questionnaire to estimate EPA fine-exposure level across five compliance dimensions.',
        href: '/tools/epa-section-608-risk-estimator',
    },
    {
        id: 'refrigerant-log-generator',
        name: 'Refrigerant Log Generator',
        description: 'Fill a service-log form and download a print-ready EPA-compliant PDF record with auto-calculated leak rate.',
        href: '/tools/refrigerant-log-generator',
    },
    {
        id: 'epa-audit-checklist',
        name: 'EPA Audit Checklist',
        description: 'Interactive 28-question audit readiness checklist that scores your compliance and gives an action plan.',
        href: '/tools/epa-audit-checklist',
    },
    {
        id: 'spreadsheet-templates',
        name: 'Spreadsheet Templates',
        description: 'Download ready-made refrigerant tracking spreadsheets with embedded formulas for leak-rate and compliance.',
        href: '/tools/spreadsheet-templates',
    },
    {
        id: 'refrigerant-phaseout',
        name: 'Refrigerant Phaseout Lookup',
        description: 'Search and compare refrigerant phaseout status, GWP, safety class, and approved substitutes.',
        href: '/tools/refrigerant-phaseout',
    },
] as const
